import {productModuleName} from 'modules/product-card/slice';
import {IProductState} from 'modules/product-card/types';
import {TAppRootState} from 'core/redux/types';

const select = (state: TAppRootState): IProductState => state[productModuleName];

export const selectProductData = (state: TAppRootState): IProductState['currentProductData'] =>
    select(state).currentProductData;

export const selectProductSeo = (state: TAppRootState): IProductState['currentProductSeo'] =>
    select(state).currentProductSeo;

export const selectProductCounterCount = (state: TAppRootState): IProductState['productCounter']['count'] =>
    select(state).productCounter.count;
